import {observable} from 'mobx';
import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';


class GiftVoucherTreatmentsOptions extends APIRequestState {
  getRequest(cityId) {
    return this.ctx.sdk.get(`/gift-vouchers-treatment-options?city_id=${cityId}`);
  }
}

class GiftsState {
  @lazyInitialize @nonenumerable giftVoucherTreatmentOptions = new GiftVoucherTreatmentsOptions(this.ctx);

  get DATE_FORMAT() { return 'YYYY/MM/DD'; }

  @observable giftDisplayText = '';

  @observable orderContent = {};

  @nonenumerable
  listeners = [];

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }
}

export default GiftsState;



// WEBPACK FOOTER //
// ./spa/state/gifts.jsx